import React from 'react';
import { NavLinkProps, NavLink, useLocation } from 'react-router-dom';

export const StatedNavLink = ({
  to,
  initialState,
  ...rest
}: NavLinkProps & {
  initialState?: Record<string, string | number | boolean>;
}) => {
  const { state, key } = useLocation();

  if (!rest.replace && !initialState) {
    return <NavLink to={to} {...rest} />;
  }

  if (typeof to === 'object') {
    return (
      <NavLink
        to={{
          ...to,
          state: {
            ...initialState,
            ...(state as any),
            ...(!key ? { __clearBack: true } : {}),
            ...(to.state as any),
          },
        }}
        {...rest}
      />
    );
  }

  if (typeof to === 'string') {
    return (
      <NavLink
        to={{
          pathname: to,
          state: {
            ...initialState,
            ...(!key ? { __clearBack: true } : {}),
            ...(state as any),
          },
        }}
        {...rest}
      />
    );
  }

  return <NavLink to={to} {...rest} />;
};
